import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import ReactBodymovin from 'react-bodymovin';
import { resetAllAnswers } from '../redux/actions';
import { PALETTES } from '../data/constants';
import animation from '../content/CuriosoLogoFont.json';

class Title extends Component {
  constructor(props) {
    super(props);
    this.bmData = {
      loop: false,
      autoplay: true,
      prerender: true,
      animationData: animation,
    };
  }

  componentDidMount() {
    this.props.resetAllAnswers();

    let { dark, light } = PALETTES[1];
    const backgrounds = document.getElementsByClassName("QuestionBackground");
    for(let i = 0; i < backgrounds.length; i++) {
      backgrounds[i].style.setProperty('--light-color', light);
      backgrounds[i].style.setProperty('--dark-color', dark);
    }

    dark = PALETTES[2].dark;
    light = PALETTES[2].light;
    const blobs = document.getElementsByClassName("Blob");
    for(let i = 0; i < blobs.length; i++) {
      blobs[i].style.setProperty('--light-color', light);
      blobs[i].style.setProperty('--dark-color', dark);
      blobs[i].style.setProperty('--light-color-contrast', PALETTES[4].light);
      blobs[i].style.setProperty('--dark-color-contrast', PALETTES[4].dark);
    }
  }

  render() {
    return <div className="Container LandingBackground">
      <ReactBodymovin options={this.bmData} />
      <h1 id="title" >Which Curioso Are You?</h1>
      <Link className="start" to="/quiz/0">
        <div className="Blob Interactive">
          <h2>Start👉</h2>
        </div>
      </Link>

      <div className="description">
        <p>
        What’s a Curioso? Curiosos are creatures that grow with you on your journey to become a stronger reader.
        Learn more about Curiosos in <a href="https://amplify.com/programs/amplify-reading">Boost Reading</a>, a personalized reading program for grades K–5.
        </p>
      </div>

      <div className="disclaimer-links">
        <a href="https://amplify.com/site-terms/" target="_blank">
          Site Terms
        </a>
        <a href="https://amplify.com/site-privacy/" target="_blank">
          Site Privacy
        </a>
      </div>

    </div>
  }
} 

export default connect(null, { resetAllAnswers })(Title);